import React from "react";
import "../../styles/atoms.scss";
import "../../styles/EventTemp.scss";

/**
 * Japanese privacy notice for online UUD CAMP event registration (/camp/event).
 * Standard event-registration scope: collection, use, subcontractors, retention, rights.
 */
const CampEventPrivacyPolicy = () => {
  return (
    <div className="event-temp-page camp-event-privacy">
      <header className="camp-event-privacy__bar">
        <a className="camp-event-privacy__back" href="/camp/event">
          ← UUD CAMP イベントページに戻る
        </a>
      </header>

      <div className="static-hero camp-event-privacy__hero">
        <h1 className="big-title">
          プライバシーポリシー
          <br />
          <span className="camp-event-privacy__title-sub">（オンラインイベント参加お申し込み）</span>
        </h1>

        <div className="static-content camp-event-privacy__content">
          <p>
            「UUD」（以下「当社」）が案内するオンラインイベント「UUD CAMP」に関し、本ページおよび参加お申込みフォームなど当社が本イベントのために提供するオンライン上の画面（以下「当ページ」）において取得する個人情報の取り扱いについて、本方針を定めます。
            当ページ以外の当社サービス（ユーザー登録、アカウント、プロフィール等）については、それぞれ適用される別の方針または規約がございます。
          </p>
          {/* <p>
            <strong>最終更新日：</strong>
            2026年5月30日
          </p> */}

          <h2 className="title camp-event-privacy__section-title">1. 本方針の適用範囲</h2>
          <p>
            本方針は、当ページにおけるオンラインイベント（UX/UI に関する講義・セミナー・ワークショップ等のオンライン参加を想定します）の案内および参加お申込みを通じて取得する情報に適用されます。メールやその他チャネルで個別にお問い合わせいただいた場合、その内容に応じて本方針に加え適切な説明または別途の規約・合意があることがあります。
          </p>

          <h2 className="title camp-event-privacy__section-title">2. 基本方針</h2>
          <p>
            当社は、個人情報の保護に関する法令、ガイドラインその他の規範を遵守し、参加お申込みおよびイベント運営のために必要な範囲で個人情報を取得・利用するとともに、漏えい、滅失、毀損、不正アクセスなどを防止するため適切な安全管理措置を講じます。運営上の必要性に応じ、本方針を見直します。
          </p>

          <h2 className="title camp-event-privacy__section-title">3. 取得する情報</h2>
          <p>参加お申込みフォームの送信およびサーバー側の記録により、以下の情報を取得する場合があります。</p>
          <ul>
            <li>
              <strong>必須に近い申込項目：</strong>お名前、メールアドレス、お申込みイベントの識別情報、イベント参加区分（申込タイプ／トピック等）、およびフォームにより設問として表示されている参加に関する内容（経験レベルの選択回答、関心項目、質問へのメモ、その他イベント準備や当日の質疑応答に活用するために記載いただいた内容）
            </li>
            <li>
              <strong>任意項目：</strong>会社名、職種・役割、イベントを知ったきっかけ等
            </li>
            <li>
              <strong>技術情報：</strong>お申込みリクエストに付随して記録される日時、送信元情報（IP アドレス等がサーバーログに残ることがあります）
            </li>
            <li>
              <strong>同意フラグ：</strong>本方針等への同意の有無を記録するデータ
            </li>
          </ul>

          <h2 className="title camp-event-privacy__section-title">4. 利用目的</h2>
          <p>取得した情報は、次の目的の範囲内で利用します。</p>
          <ol>
            <li>イベントの開催に向けた参加受付・本人確認および連絡（開催情報、入室用URL、資料配布、その他運営上必要なご案内をメールなどで送信するため）</li>
            <li>当日の質疑応答やセッション内容の準備への参考（参加者の関心や事前質問などの活用）</li>
            <li>参加人数規模や属性の把握（個人が特定できない形での集計を含む場合があります）</li>
            <li>不正申込やスパム、法令違反の疑いがある行為への対応</li>
            <li>UUD が今後ご案内する学習・コミュニティ関連のサービスまたはイベント情報の提供（ご案内については適用法令に沿い、不要な送信をしないよう運用いたします）</li>
            <li>法令または行政機関等の合法的な要請への対応</li>
          </ol>

          <h2 className="title camp-event-privacy__section-title">5. オンライン会議サービスとの関係</h2>
          <p>
            オンライン参加にあたって Google Meet、Zoom などのオンライン会議サービスのURLまたはアプリへの遷移をご案内する場合があります。そのサービス側での音声・画像・参加者名の取り扱いは各提供事業者のプライバシーポリシーに従いますので、サービス側の規約および設定もご確認ください。
          </p>

          <h2 className="title camp-event-privacy__section-title">6. 第三者への提供・共同利用</h2>
          <p>
            法令により認められる場合を除き、ご本人の同意なく個人情報を第三者へ提供いたしません。イベント運営上、共同主催または講師・協力企業との連携がある場合において、その範囲で共有が必要なときは、その旨と共有先・目的をお知らせし、適切な管理体制の下でのみ共有します。また、サイト運営、データベース保存、電子メール送信などの機能の一部について、適切な委託先に業務を委託することがあり、この場合にも委託先に対する監督を行います。
          </p>

          <h2 className="title camp-event-privacy__section-title">7. 国外での情報の保管</h2>
          <p>
            サーバー、電子メール、オンライン会議等の機能を利用することにより、利用するクラウド基盤等のサーバー設置場所により、ご本人様の情報が日本国外でも保管または処理される可能性があります。その場合にも、適用法令に適合した範囲で適切な保護に努めます。
          </p>

          <h2 className="title camp-event-privacy__section-title">8. Cookie およびアクセス解析</h2>
          <p>
            当ウェブサイト（当イベントページおよび当社が関連して提供する画面）においては、サイトの閲覧状況の把握や機能改善のために、Cookie やアクセス解析ツール等を利用する場合があります。
            これらにより取得される情報には、単体ですぐにご本人様を特定できるものが含まれない場合もあります。ブラウザの設定により Cookie を無効にできますが、その場合は一部機能がご利用いただけなくなることがあります。
          </p>

          <h2 className="title camp-event-privacy__section-title">9. 保管期間</h2>
          <p>
            取得した情報は、上記「利用目的」に記載された利用のために必要な期間および法令により保存することが義務付けられる期間を経過すると、合理的かつ安全な措置にもとづいて削除または匿名化します。
          </p>

          <h2 className="title camp-event-privacy__section-title">10. ご本人様からの請求（開示・訂正・利用停止など）</h2>
          <p>
            本方針の対象となる個人情報の開示・訂正・追加・削除・利用停止等の請求があったときは、法令に従い、本人確認のうえできる限り合理的に対応いたします。その場合は文末の問い合わせ窓口までご連絡ください。
          </p>

          <h2 className="title camp-event-privacy__section-title">11. 未成年の方へのお願い</h2>
          <p>
            未成年の方がお申し込みを行うときは、保護者等のご同意や指導のもとでご利用いただいてください。
          </p>

          <h2 className="title camp-event-privacy__section-title">12. 本方針の変更</h2>
          <p>
            法令または運営上の変更に伴い本方針を改定することがあります。変更後は当ページまたは合理的な手段で周知いたします。
          </p>

          <h2 className="title camp-event-privacy__section-title">
            13. お問い合わせ窓口（本イベント・当サイトにおける個人情報の取り扱い）
          </h2>
          <p>Eメールでのお問い合わせ先：info@uud.io （件名に「イベント参加」「プライバシー」などとご記載ください）</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CampEventPrivacyPolicy);
